import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { api } from "@/lib/apiClient";
import Seo from "@/components/Seo";

export default function JournalPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  const [nf, setNf] = useState(false);

  useEffect(() => { setP(null); setNf(false); api.get(`/journal/${slug}`).then((r) => setP(r.data)).catch(() => setNf(true)); }, [slug]);

  const paragraphs = useMemo(() => (p?.content || "").split("\n").filter(Boolean), [p]);

  if (nf) return <div className="pt-40 pb-32 text-center"><p className="font-display text-4xl text-[#2A1808]">Post not found</p><Link to="/journal" className="inline-block mt-6 text-[#F49E1A] font-semibold">← Journal</Link></div>;
  if (!p) return <div className="pt-40 pb-32 text-center text-[#8A6B47]">Loading…</div>;

  const jsonLd = { "@context": "https://schema.org", "@type": "Article", headline: p.title, image: p.cover_image, author: { "@type": "Organization", name: p.author }, publisher: { "@type": "Organization", name: "VacanzaGo" }, datePublished: p.created_at };

  return (
    <div className="bg-[#FFF7EC]">
      <Seo title={p.title} description={p.excerpt} image={p.cover_image} type="article" jsonLd={jsonLd} />
      <div className="relative h-[60vh] min-h-[400px]">
        <img src={p.cover_image} alt={p.title} className="h-full w-full object-cover" />
        <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(42,24,8,0.4), rgba(42,24,8,0.85))" }} />
        <div className="absolute inset-0 flex flex-col justify-end">
          <div className="max-w-3xl mx-auto w-full px-4 sm:px-8 lg:px-12 pb-12">
            <Link to="/journal" className="inline-flex items-center gap-2 text-[#F9EFE1]/80 text-sm mb-5 hover:text-white"><ArrowLeft size={16} /> Journal</Link>
            <p className="text-[#F49E1A] uppercase tracking-widest text-xs">{p.category}</p>
            <h1 className="font-display text-4xl sm:text-6xl font-medium text-white mt-2 leading-[1.05]">{p.title}</h1>
            <p className="mt-3 text-[#F9EFE1]/70 text-sm">By {p.author}</p>
          </div>
        </div>
      </div>
      <article className="max-w-2xl mx-auto px-4 sm:px-8 lg:px-12 py-14">
        <p className="font-display text-2xl text-[#553204] leading-relaxed">{p.excerpt}</p>
        <div className="mt-6 space-y-5 text-[#553204] leading-relaxed text-lg">
          {paragraphs.map((para, i) => <p key={`para-${i}`}>{para}</p>)}
        </div>
      </article>
    </div>
  );
}
